import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { MultipleActionsParams } from "go-list/list/services/types";
import { adminApi } from "../../../../../../../../../../../services/Api/Admin/adminApi";
import { CrashReportApi } from "../../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	isShown: boolean;
	onHide: () => void;
	setCrashReport?: (crashReport: CrashReportApi) => void;
	ids: number[];
	include?: string;
	handleSuccessAction?: () => void;
	multipleActionsParams?: MultipleActionsParams;
	areAllItemsSelected?: boolean;
}

interface FormProps {
	comment: string;
}

const CrashReportMarkAsPermanentlyBrokenModal = ({
	onHide,
	isShown,
	setCrashReport,
	ids,
	include,
	handleSuccessAction,
	multipleActionsParams,
	areAllItemsSelected,
}: Props) => {
	const { t } = useTranslation("admin");
	const [loading, setLoading] = useState(false);
	const form = useForm<FormProps>({
		criteriaMode: "all",
	});
	const { addFlash, addSuccessFlash } = useFlash();
	const {
		formState,
		formState: { errors },
		register,
		handleSubmit,
		setError,
	} = form;

	const onSubmit = handleSubmit(async (data: FormProps) => {
		setLoading(true);
		try {
			let res;
			if (ids.length > 1) {
				const params: Record<string, any> = multipleActionsParams ? { ...multipleActionsParams } : {};
				if (areAllItemsSelected === false) params.ids = ids;
				await adminApi.markAsPermanentlyBrokenCrashReports(ids, data, params);
			} else {
				res = await adminApi.markAsPermanentlyBrokenCrashReport(ids[0], data, { include: include ?? "" });
				setCrashReport && setCrashReport(res);
			}
			handleSuccessAction && handleSuccessAction();
			addSuccessFlash(t("common.flash.completed", { ns: "lib" }));
			onHide();
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal show={isShown} onHide={onHide}>
			<FormDirty formState={formState} onSubmit={onSubmit}>
				<Modal.Header closeButton>
					<Modal.Title>{t("modules.crash_report.action.mark_as_permanently_broken.title")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormInput
						name="comment"
						errors={errors}
						register={register}
						label={t("lib:common.word.comment")}
					/>
				</Modal.Body>
				<Modal.Footer>
					<ButtonLoading loading={loading} type="submit" onClick={onSubmit}>
						{t("lib:common.action.save")}
					</ButtonLoading>
					<Button variant="light" onClick={onHide}>
						{t("lib:common.action.cancel")}
					</Button>
				</Modal.Footer>
			</FormDirty>
		</Modal>
	);
};

export default CrashReportMarkAsPermanentlyBrokenModal;
